export default __webpack_public_path__ + "static/media/happy.44d7c736.svg";